import './unloadingDetailsPopover.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { useState, useEffect } from 'react';
import apiClient from "../../../axios";
import jwt from 'jwt-decode';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { Container, Card, CardContent, TextField, Typography, Grid, Box, Button } from '@mui/material';
import { PIT_VALIDATIONS } from '../../../common/commonValidations';
import { handleNumberFieldFocus } from '../../../common/commonFunction';

export const OdoMeterPopover = (props) => {

  const [odoMeterReading, setOdometerReading] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [cofirmMessage, setConfirmMessage] = useState("");

  const endTrip = () => {
    let data = {
      consignmentNo: props.consignmentNumber,
      odometerReading: odoMeterReading
    };
    props.handleLogModalClose();
    props.tripEnded(data);

  }

  const handleOdometerChange = (e) => {
    const isValid = PIT_VALIDATIONS.validation(e.target.value)
    isValid && setOdometerReading(parseFloat(e.target.value));
  }

  return (
    <>
      <Container maxWidth="xl">
        <Typography variant="h5" gutterBottom>
          End Trip
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField fullWidth 
            label='Odometer End Reading' 
            value={odoMeterReading} 
            onChange={(e) => handleOdometerChange(e)} 
            type="number"
            onFocus={handleNumberFieldFocus}
            name="" 
            />
          </Grid>
        </Grid>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          <Button onClick={props.handleLogModalClose}>Cancel</Button>
          <Button onClick={endTrip}>Submit</Button>
        </Box>

      </Container>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={cofirmMessage} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogModalOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </>

  );
};
